import { getConfigsLocal } from '../../illustrations/models/illustrationConfigs';
import { configKeysList } from '../models/config-keys';

function ConfigProvider({ configKey, alternate, children }) {
    // Check if configKey exists in configKeysLis
    if (!configKeysList.includes(configKey)) {
        throw new Error(
            'Invalid configKey passed as argument. Please add your config key to configKeys object.'
        );
    }
    // Check if configKey exists in configs retrieved from server
    if (!(configKey in getConfigsLocal())) {
        throw new Error(
            'Invalid configKey passed as argument. Please add your config key to the server.'
        );
    }
    if (getConfigsLocal()[configKey].value) {
        return children;
    } else {
        return alternate ? alternate : null;
    }
}

export default ConfigProvider;
